import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

class DeleteAction extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {id,title, message, okBtn}=this.props
        const deleteAction =()=>{
            if(this.props.onDelete) {
                this.props.onDelete()
            }
          
        }

        return (
            <div class="modal fade delete-modal bg-overlay" id={`${id?id:"deleteOnConversationModal"}`}>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 text-black text-semi-bold mb0">{`${title?title:'Delete this File?'}`}</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a class="text-right text-black" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body">
                            <p class="m0 text-black">{`${message?message:"This file will be deleted in this conversation. Do you wish to proceed?"}`}</p>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btn-cancel text-black ml0" data-dismiss="modal">Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class="btn btn-danger btn-delete" onClick={deleteAction}>{`${okBtn?okBtn:'Delete'}`}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteAction;
